/* eslint-disable prefer-const */
import moment from 'moment';
import _ from 'lodash';

/**
  Remove Tag
**/
export const removeTag = (textWithTag: string) => textWithTag.replace(/(<([^>]+)>)/gi, '');

/**
  Remove All Tag
**/
export const removeAllTag = (textWithTag: string) => {
  let retValue = '';
  retValue = textWithTag.replace(/(<([^>]+)>)/gi, '');
  retValue = retValue.replace(/&nbsp;/gi, '');
  retValue = retValue.trim();
  return retValue;
};

/**
  Remove All Tag Except Img Tag
**/
export const removeAllTagExceptImgTag = (textWithTag: string) => {
  let retValue = textWithTag.replace(/<(?!img\b)[^>]*>/gi, '');
  retValue = retValue.replace(/&nbsp;/gi, '');
  retValue = retValue.trim();
  return retValue;
};

/**
  unescape string
**/
export const unescape = (content: string) => {
  let retContent = '';
  const contionSet = content.replaceAll('&amp;', '&');
  retContent = _.unescape(contionSet || '');
  return retContent;
};

/**
  unescape string
**/
export const removeChart = (content: string, charLeng: number) => {
  let retContent = content;
  if (content.length > charLeng) {
    retContent = content.substring(0, charLeng) + '...';
  }
  // const contionSet = content.replaceAll('&amp;', '&');
  // retContent = _.unescape(contionSet || '');
  return retContent;
};

/**
  unescape string
**/
const digitsOnly = (rrn: string) => {
  return (rrn || '').replace(/\D/g, '');
};
export const calculateChecksum = (digs12: string) => {
  // rrn.js (추가 기능)
  const WEIGHTS = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];

  const arr = digs12.split('').map(Number);
  const sum = WEIGHTS.reduce((acc, w, i) => acc + arr[i] * w, 0);
  return ((11 - (sum % 11)) % 10) + '';
};
export const getResidentId = (rrn: string) => {
  const raw = digitsOnly(rrn);
  if (raw.length === 13) {
    return raw.slice(0, 6) + '-' + raw.slice(6);
  }
  if (raw.length === 12) {
    const cd = calculateChecksum(raw);
    const full = raw + cd;
    return full.slice(0, 6) + '-' + full.slice(6);
  }

  return '';
};

export const formatRRN = (value: string): string | false => {
  // 숫자와 - 만 허용
  if (!/^[0-9-]*$/.test(value)) return false;
  // - 제거 후 숫자만 추출
  const numbers = value.replace(/-/g, '');
  // 13자리 초과 방지
  if (numbers.length > 13) return false;

  // 7번째 위치에 - 추가
  if (numbers.length <= 6) {
    return numbers;
  } else {
    return numbers.slice(0, 6) + '-' + numbers.slice(6);
  }
};

export function validateRRN(rrn: string): boolean {
  if (!rrn) return false;

  // 숫자만 추출 (예: 900101-1234567)
  const value = rrn.replace(/-/g, '');

  // 숫자 13자리인지 확인
  if (!/^\d{13}$/.test(value)) {
    return false;
  }

  const front = value.substring(0, 6);
  const genderCode = Number(value.charAt(6));

  // 생년월일 검증
  const month = Number(front.substring(2, 4));
  const day = Number(front.substring(4, 6));

  // 7번째 자리 기준 세기 확인
  let year: number;

  switch (genderCode) {
    case 1:
    case 2:
      year = 1900 + Number(front.substring(0, 2));
      break;

    case 3:
    case 4:
      year = 2000 + Number(front.substring(0, 2));
      break;

    case 5:
    case 6:
      // 외국인등록번호
      year = 1900 + Number(front.substring(0, 2));
      break;

    case 7:
    case 8:
      // 외국인등록번호
      year = 2000 + Number(front.substring(0, 2));
      break;

    default:
      return false;
  }

  // 실제 날짜인지 검증
  const date = new Date(year, month - 1, day);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return false;
  }

  return true;
  // 체크디짓 검증
  // const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];

  // const sum = weights.reduce((acc, weight, index) => {
  //   return acc + Number(value.charAt(index)) * weight;
  // }, 0);

  // const checkDigit = (11 - (sum % 11)) % 10;

  // return checkDigit === Number(value.charAt(12));
}

// 주민번호 검증
export function validateOldRRN_As1(rrn: string): boolean {
  if (!rrn) return false;
  // 하이픈 제거
  const clean = rrn.replace(/-/g, '');
  // 숫자 13자리 체크
  if (!/^\d{13}$/.test(clean)) return false;
  const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];

  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number(clean[i]) * weights[i];
  }

  let checkDigit = 11 - (sum % 11);
  if (checkDigit >= 10) {
    checkDigit = checkDigit % 10;
  }
  return checkDigit === Number(clean[12]);
}

export function validateRRN_As2(rrn: string): boolean {
  if (!rrn) return false;

  // 하이픈 제거
  const clean = rrn.replace(/-/g, '');

  // 숫자 13자리 체크
  if (!/^\d{13}$/.test(clean)) return false;

  // 생년월일
  const yy = Number(clean.substring(0, 2));
  const mm = Number(clean.substring(2, 4));
  const dd = Number(clean.substring(4, 6));

  // 7번째 자리
  const genderCode = Number(clean[6]);

  // 7번째 자리로 출생 세기 판단
  let year: number;

  switch (genderCode) {
    case 1:
    case 2:
    case 5:
    case 6:
      year = 1900 + yy;
      break;

    case 3:
    case 4:
    case 7:
    case 8:
      year = 2000 + yy;
      break;

    case 9:
    case 0:
      year = 1800 + yy;
      break;

    default:
      return false;
  }

  // 생년월일 유효성 검사
  const date = new Date(year, mm - 1, dd);

  if (date.getFullYear() !== year || date.getMonth() !== mm - 1 || date.getDate() !== dd) {
    return false;
  }

  // 주민등록번호 검증번호 계산
  const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];

  let sum = 0;

  for (let i = 0; i < 12; i++) {
    sum += Number(clean[i]) * weights[i];
  }

  let checkDigit = 11 - (sum % 11);

  if (checkDigit >= 10) {
    checkDigit %= 10;
  }

  return checkDigit === Number(clean[12]);
}

export function isAge70OrOver(rrn: string): boolean {
  if (!rrn) return false;
  const clean = rrn.replace(/-/g, '');
  // 주민번호 13자리
  if (!/^\d{13}$/.test(clean)) return false;

  const yy = Number(clean.substring(0, 2));
  const mm = Number(clean.substring(2, 4));
  const dd = Number(clean.substring(4, 6));
  const genderCode = Number(clean[6]);

  // 7번째 자리 기준 출생년도
  let year: number;

  switch (genderCode) {
    case 1:
    case 2:
      year = 1900 + yy;
      break;

    case 3:
    case 4:
      year = 2000 + yy;
      break;

    default:
      return false;
  }

  const birthDate = new Date(year, mm - 1, dd);

  // 생년월일 유효성 검사
  if (
    birthDate.getFullYear() !== year ||
    birthDate.getMonth() !== mm - 1 ||
    birthDate.getDate() !== dd
  ) {
    return false;
  }

  const today = new Date();
  let age = today.getFullYear() - year;
  // 올해 생일이 아직 지나지 않았다면 -1
  const birthdayNotPassed =
    today.getMonth() < mm - 1 || (today.getMonth() === mm - 1 && today.getDate() < dd);

  if (birthdayNotPassed) {
    age--;
  }

  return age >= 70;
}

/**
 * 주민번호로 출생연도 추출 (형식이 유효하지 않으면 null)
 */
export function getBirthYearFromRRN(rrn: string): number | null {
  if (!rrn) return null;
  const clean = rrn.replace(/-/g, '');
  // 주민번호 13자리
  if (!/^\d{13}$/.test(clean)) return null;

  const yy = Number(clean.substring(0, 2));
  const genderCode = Number(clean[6]);

  switch (genderCode) {
    case 1:
    case 2:
      return 1900 + yy;

    case 3:
    case 4:
      return 2000 + yy;

    default:
      return null;
  }
}

/**
 * 주민번호로 생년월일 추출, 형제간 생일 순서 비교 등에 사용 (YYYYMMDD 숫자, 형식이 유효하지 않으면 null)
 */
export function getBirthDateFromRRN(rrn: string): number | null {
  if (!rrn) return null;
  const clean = rrn.replace(/-/g, '');
  // 주민번호 13자리
  if (!/^\d{13}$/.test(clean)) return null;

  const birthYear = getBirthYearFromRRN(rrn);
  if (birthYear === null) return null;

  const mm = clean.substring(2, 4);
  const dd = clean.substring(4, 6);

  return Number(`${birthYear}${mm}${dd}`);
}

/**
 * 귀속연도(과세기간 종료일) 기준 특정 나이 이상 여부
 * 세법상 나이는 해당 귀속연도 12/31 기준으로 계산하므로 생일 경과 여부와 무관하게 출생연도만 비교한다.
 */
export function isAgeOverByYear(rrn: string, acctYear: string | number, minAge: number): boolean {
  if (!rrn) return false;
  const clean = rrn.replace(/-/g, '');
  // 주민번호 13자리
  if (!/^\d{13}$/.test(clean)) return false;

  const yy = Number(clean.substring(0, 2));
  const genderCode = Number(clean[6]);

  // 7번째 자리 기준 출생년도
  let birthYear: number;

  switch (genderCode) {
    case 1:
    case 2:
      birthYear = 1900 + yy;
      break;

    case 3:
    case 4:
      birthYear = 2000 + yy;
      break;

    default:
      return false;
  }

  const targetYear = Number(acctYear);
  if (!targetYear) return false;

  return targetYear - birthYear >= minAge;
}

/**
 * 귀속연도(과세기간 종료일) 기준 만 70세 이상 여부
 */
export function isAge70OrOverByYear(rrn: string, acctYear: string | number): boolean {
  return isAgeOverByYear(rrn, acctYear, 70);
}

export function makeTestRRN(
  birth: string, // YYMMDD
  genderCode: string // 1~4
): string {
  const base = birth + genderCode + '00000';
  const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  let sum = 0;

  for (let i = 0; i < 12; i++) {
    sum += Number(base[i]) * weights[i];
  }
  let checkDigit = 11 - (sum % 11);

  if (checkDigit >= 10) {
    checkDigit %= 10;
  }

  return `${base.substring(0, 6)}-${base.substring(6)}${checkDigit}`;
}

// 사업자 번호
export function validateBizNo(bizNo: string): boolean {
  // 1. 하이픈 제거
  const cleaned = bizNo.replace(/-/g, '');
  // 2. 숫자 10자리 체크
  if (!/^\d{10}$/.test(cleaned)) return false;
  const weights = [1, 3, 7, 1, 3, 7, 1, 3, 5];
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(cleaned[i]) * weights[i];
  }
  // 9번째 자리 (index 8) × 5 → 십의 자리 추가
  sum += Math.floor((Number(cleaned[8]) * 5) / 10);
  const checkDigit = (10 - (sum % 10)) % 10;
  console.log(checkDigit, Number(cleaned[9]));

  return checkDigit === Number(cleaned[9]);
}

export const bizNumChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const onlyNumber = e.target.value.replace(/[^0-9]/g, '');
  if (onlyNumber.length <= 10) {
    // setValue(onlyNumber);
    return onlyNumber;
  }
};

export const formatBizNo = (value: string): string | false => {
  // 숫자와 - 만 허용
  if (!/^[0-9-]*$/.test(value)) return false;

  // - 제거
  const numbers = value.replace(/-/g, '');

  // 10자리 초과 방지
  if (numbers.length > 10) return false;

  // 3-2-5 자동 하이픈
  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 5) {
    return numbers.slice(0, 3) + '-' + numbers.slice(3);
  } else {
    return numbers.slice(0, 3) + '-' + numbers.slice(3, 5) + '-' + numbers.slice(5);
  }
};

export const getBizNo = (bizNo: string) => {
  const raw = bizNo.replace(/\D/g, ''); // 숫자만

  const weights = [1, 3, 7, 1, 3, 7, 1, 3, 5];

  const calculateChecksum = (num: string) => {
    let sum = 0;

    for (let i = 0; i < 9; i++) {
      sum += Number(num[i]) * weights[i];
    }

    // 9번째 자리 × 5 → 십의 자리 추가
    sum += Math.floor((Number(num[8]) * 5) / 10);

    return (10 - (sum % 10)) % 10;
  };

  // 10자리 완성
  if (raw.length === 10) {
    return raw.slice(0, 3) + '-' + raw.slice(3, 5) + '-' + raw.slice(5);
  }

  // 9자리면 체크숫자 자동 생성
  if (raw.length === 9) {
    const cd = calculateChecksum(raw);
    const full = raw + cd;

    return full.slice(0, 3) + '-' + full.slice(3, 5) + '-' + full.slice(5);
  }

  return '';
};
